<div class="container py-5">
  @if (profile$ | async; as profile) {

  <div class="card shadow-sm p-4 mx-auto mb-4">
    <div class="text-center mb-3">
      @if (profile.image) {
      <img [src]="profile.image.startsWith('http') ? profile.image : 'data:image/png;base64,' + profile.image"
        class="rounded-circle" style="width: 120px; height: 120px; object-fit: cover;" />
      }
    </div>

    <h3 class="text-center mb-1">{{ profile.fullName }}</h3>
    <p class="text-center text-muted mb-3">{{ profile.headline }}</p>

    <div class="mb-1">
      <h5><strong>Email:</strong></h5>
      <div>{{ profile.email }}</div>
    </div>
    <hr class="divider">

    <div class="mb-2">
      <h5><strong>About:</strong></h5>
      <div>{{ profile.bio }}</div>
    </div>
    <hr class="divider">
    
    @if(!profile.companyId) {
    <div class="section-card mb-2">
      <div class="mb-3">
        <h3 class="mb-0">Skills & Badges</h3>
      </div>

      @if(profile.skills.length > 0) {
      <div class="card-list mb-2">
        @for (skill of profile.skills; track skill.id) {
        <div class="skill-chip">
          <div class="d-flex align-items-center gap-2">
            <h5 class="mb-0">{{ skill.name }}</h5>
            <img class="size" [src]="badgeService.getBadgeIconForSkill(skill.name, profile.badges)" />
          </div>

          @if (skill.assessments && skill.assessments.length > 0) {
          <div class="d-flex gap-2 align-items-center">
            <select #testSelect class="form-select form-skill">
              <option value="">-- Select Test --</option>
              @for (assessment of skill.assessments; track assessment.id) {
              <option [value]="assessment.id">
                {{ assessment.title || 'Test' }} ({{ assessment.difficultyLevel }})
              </option>
              }
            </select>
            <a class="btn btn-sm search-btn"
              [routerLink]="testSelect.value ? ['/skill', skill.id, 'test', testSelect.value] : null">
              <i class="bi bi-journal-check me-1"></i>Take Test
            </a>
          </div>
          } @else {
          <div class="text-muted small">No tests available</div>
          }
        </div>
        }
      </div>
      } @else {
      <div class="card-list">
        <p class="text-muted mb-0">No skills added yet.</p>
      </div>
      }
    </div>
    <hr class="divider">
    
    <h5>Education:</h5>
    @if (educations$ | async; as educationsList) {
      @if (educationsList.length > 0) {
      <div class="card-list p-3 mb-3">
        @for (education of educationsList; track $index) {
        <div class="education-card">
          <div class="card-left">
            <h4 class="mb-0">{{ education.school }}</h4>
            <h5 class="mb-0">{{ education.fieldOfStudy }}</h5>
            <p class="mb-1"><strong>{{ education.degree }}</strong></p>
            <p class="mb-0">
              {{ education.startDate | date:'yyyy-MM-dd' }} -
              {{ education.endDate ? (education.endDate | date:'yyyy-MM-dd') : 'Ongoing' }}
            </p>
          </div>
        </div>
        }
      </div>
      } @else {
      <p class="text-muted small mb-0">No education entries yet.</p>
      }
    }
    <hr class="divider">

    <h5 class="mb-3 mt-1">Work experiences:</h5>
    @if (experiences$ | async; as experiencesList) {
      @if(experiencesList.length > 0){
      <div class="card-list p-3 mb-2">
        @for(experience of experiencesList; track $index){
        <div class="experience-card">
          <div class="card-left">
            <h4 class="mb-0">{{experience.companyName}}</h4>
            <h5 class="mb-0">{{experience.jobTitle}}</h5>
            <p class="mb-0">{{experience.startDate | date:'yyyy-MM-dd'}} - {{experience.endDate | date: 'yyyy-MM-dd'}}
            </p>
          </div>
        </div>
        }
      </div>
      } @else {
      <p class="text-muted small mb-0">No experience entries yet.</p>
      }
    }
    }
    
    <div class="text-start mt-3">
      <button class="btn search-btn" routerLink="/editProfile">
        <i class="bi bi-person-gear me-1"></i>Edit Profile
      </button>
    </div>

  </div>

  @if (profile.companyId) {
  <div class="card shadow-sm p-4 mx-auto" style="max-width: 800px;">
    <h4 class="mb-4 text-center">My Posted Jobs</h4>

    @if (companyJobs$ | async; as jobs) {
    @if (jobs.length > 0) {
    <div class="row g-3">
      @for (job of jobs; track job.id) {
      <div class="col-12">
        <div class="card border-light bg-light">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h5 class="card-title mb-1">{{ job.title }}</h5>
                <h6 class="card-subtitle text-muted small">
                  <i class="bi bi-geo-alt-fill me-1"></i>{{ job.location }}
                </h6>
              </div>
              <div class="d-flex gap-2">
                <button class="btn btn-sm btn-outline-primary" [routerLink]="['/editJob', job.id]">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" (click)="deleteJob(job.id, profile.id)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>

            <div class="d-flex flex-wrap gap-1 mt-3">
              @for (tag of job.tags; track tag) {
              <span class="badge bg-secondary bg-opacity-25 text-dark" style="font-size: 0.75rem;">
                {{ tag }}
              </span>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    } @else {
    <div class="text-center text-muted py-3">
      <p class="mb-0">You have not posted any jobs yet.</p>
    </div>
    }
    }
  </div>
  } @else {
  <div class="card shadow-sm p-4 mx-auto" style="max-width: 600px;">
    <h4 class="mb-4 text-center"><i class="bi bi-bookmark-heart text-primary me-2"></i>Saved Jobs</h4>

    @if (savedJobs$ | async; as savedJobs) {
    @if (savedJobs.length > 0) {
    <div class="row g-3">
      @for (job of savedJobs; track job.id) {
      <div class="col-12">
        <div class="card border-light bg-light" style="cursor: pointer;" [routerLink]="['/job', job.id]">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h5 class="card-title mb-1 text-primary">{{ job.title }}</h5>
                <h6 class="card-subtitle text-muted small">
                  <i class="bi bi-geo-alt-fill me-1"></i>{{ job.location || 'Unknown' }}
                </h6>
              </div>
              <div>
                <button class="btn btn-sm btn-outline-danger" (click)="removeSavedJob(job.id, $event)"
                  title="Remove from saved">
                  <i class="bi bi-bookmark-x"></i>
                </button>
              </div>
            </div>

            <div class="d-flex flex-wrap gap-1 mt-3">
              @for (tag of job.tags; track tag) {
              <span class="badge bg-secondary bg-opacity-25 text-dark" style="font-size: 0.75rem;">
                {{ tag }}
              </span>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    } @else {
    <div class="text-center text-muted py-3">
      <p class="mb-0">You have no saved jobs. Browse the job board and bookmark some!</p>
    </div>
    }
    }
  </div>
  }

  }
</div>